import React from 'react';
import { FaEdit } from '@react-icons/all-files/fa/FaEdit';
import { Button } from 'antd';
import './index.scss';

const ContactInfoStep = (props) => {
  const { params, onChange } = props;
  const onContinueClick = () => {
    props.onContinueClick && props.onContinueClick();
  };
  const onBackClick = () => {
    props.onBackClick && props.onBackClick();
  };
  return (
    <div className="step contact-info-step">
      <div className="step-inner-content">
        <div className="step-header">
          <h2>Contact information </h2>
          <p>Including your contacts in your resume is crucial so potential employers can easily get in touch with you.</p>
        </div>
        <div className="step-fields">
          <div className="row">
            <div className="field">
              <label>Email</label>
              <input
                type="email"
                placeholder="john@example.com"
                value={params.email || ''}
                onChange={e => onChange('email', e.target.value)}
              />
            </div>
            <div className="field">
              <label>Phone</label>
              <input
                type="text"
                placeholder="+1 999 888 7777"
                value={params.phoneNumber || ''}
                onChange={e => onChange('phoneNumber', e.target.value)}
              />
            </div>
          </div>
          <div className="row">
            <div className="field">
              <label>Country</label>
              <input
                type="text"
                placeholder="USA"
                value={params.country || ''}
                onChange={e => onChange('country', e.target.value)}
              />
            </div>
            <div className="field">
              <label>City</label>
              <input
                type="text"
                placeholder="Austin"
                value={params.city || ''}
                onChange={e => onChange('city', e.target.value)}
              />
            </div>
          </div>
          <div className="row">
            <div className="field">
              <label>Address</label>
              <input
                type="text"
                placeholder="709 9th St NW"
                value={params.address || ''}
                onChange={e => onChange('address', e.target.value)}
              />
            </div>
            <div className="field">
              <label>Postal code</label>
              <input
                type="text"
                placeholder="55912"
                value={params.zipcode || ''}
                onChange={e => onChange('zipcode', e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="step-footer">
        <button className="back-btn" onClick={onBackClick}>&larr; Back</button>
        <Button loading={props.formLoading} className="next-btn" onClick={onContinueClick}>Next <span className="arrow">&rarr;</span></Button>
      </div>
    </div>
  );
};

export default ContactInfoStep;
